import { Component, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { IUser } from '@interfaces/IUser';
import { IAppState } from '@myStore/app.state';
import {
  SendBlockStudentRequest,
  SendNoteAboutStudentRequest,
} from '@myStore/users-changes/users-changes.actions';
import { Store } from '@ngrx/store';
import { FormDialogComponent } from '@shared/components/UI/form-dialog/form-dialog.component';
import { isControlsIsValid } from '@shared/utils/formUtils';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-user-deactiveted-form',
  templateUrl: './user-deactiveted-form.component.html',
  styleUrls: ['./user-deactiveted-form.component.sass'],
})
export class UserDeactivetedFormComponent implements OnInit {
  deductionForm = new UntypedFormGroup({
    student: new UntypedFormControl(''),
    type: new UntypedFormControl('blocking'),
    text: new UntypedFormControl('', [Validators.required]),
  });

  public student?: IUser;

  sendLoading$!: Observable<boolean>;
  groupId?: number;
  studentListStatus?: string;

  constructor(
    public dialogRef: MatDialogRef<FormDialogComponent>,
    private _store: Store<IAppState>
  ) {}

  ngOnInit(): void {
    const dialogData = this.dialogRef.componentInstance.data;
    this.student = dialogData.student;
    this.groupId = dialogData.groupId;
    this.sendLoading$ = dialogData.loading$;

    this.deductionForm.patchValue({
      student: dialogData.student?.id,
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSubmit() {
    const data = this.deductionForm.value;

    if (isControlsIsValid(this.deductionForm.controls)) {
      this._store.dispatch(new SendNoteAboutStudentRequest(data));

      if (this.student?.id) {
        this._store.dispatch(new SendBlockStudentRequest(this.student.id));
      }
    }
  }
}
